/*
 * @Author: zhaoyang
 * @Date: 2020-11-25 14:26:13
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 15:34:27
 * @Description: 发送系统通知（首先系统应允许浏览器发送通知）
 */
import i18n from '@/locales/index'
export default function notify(title, options, time = 5000) {
  if (!('Notification' in window)) {
    console.error(
      'Sorry bro, your browser is not good enough to display notification'
    );
    return new Promise();
  }
  return new Promise(resolve => {
    Notification.requestPermission(function(permission) {
      let notification;
      // 统一授权通知
      if (permission === 'granted') {
        console.log(permission);
        notification = new Notification(title, options);
        setTimeout(function() {
          notification.close(); //关闭桌面通知
        }, time);
        resolve(notification);
      } else if (permission === 'denied') {
        console.log(permission);
      }
      notification.onerror = function(e) {
        //当有错误发生时会onerror函数会被调用
        console.error(e);
      };
    });
  });
}

/**
 * @description: 提醒用戶開啟web通知
 */
export async function requestPermission(preFn) {
  if (!('Notification' in window)) {
    console.error(
      'Sorry bro, your browser is not good enough to display notification'
    );
    return Promise.resolve()
  }
  let needPermission = Notification.permission !== 'granted'
  if(!needPermission) return Promise.resolve()
  if (typeof preFn === 'function'){
    let status = await preFn()
    if(!status) return Promise.resolve()
  } 
  return new Promise((resolve) => {
    Notification.requestPermission(function(permission) {
      // 统一授权通知
      if (permission === 'granted') {
        let notification = new Notification(i18n.t('utils_web_notification_2425'));
        setTimeout(function() {
          notification.close(); //关闭桌面通知
        }, 6000);
        resolve(notification)
      } else {
        resolve(false)
      }
    });
  });
}
